module.exports = __webpack_public_path__ + "static/media/undraw_hello_re_3evm.dee0d050.svg";